import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { EnrollCourseMaster } from '../model/EnrollCourseMaster.model';
import { ExamMaster } from '../model/ExamMaster.model';
import { ExamMCQMaster } from '../model/ExamMCQMaster.model';
import { LookupData } from '../model/LookupData.model';
import { MCQOptionMaster } from '../model/MCQOptionMaster.model';
import { StudentLectureMaster } from '../model/StudentLectureMaster.model';
import { StudentLectureMcqMaster } from '../model/StudentLectureMcqMaster.model';
import { AuthService } from '../service/auth.service';
import { MainserviceService } from '../service/mainservice.service';

declare var require: any
const FileSaver = require('file-saver');

@Component({
  selector: 'app-assessment',
  templateUrl: './assessment.component.html',
  styleUrls: ['./assessment.component.scss']
})
export class AssessmentComponent implements OnInit {
  examfinish:boolean=false;

  timerSeconds: number = 0;
  timerMinute: number = 0;
  actualSeconds: number = 0;
  interval;
  showEndExamDialog = false;

  nextButtonText: string = "Next";
  prevButtonText: string = "Previous";
  cancelButtonText: string = "Close";

  showPreviousButton:boolean = true;
  showCancelButton:boolean = false;
  showNextButton:boolean = true;

  errorMessage: string = "";

  studentLectureMaster: StudentLectureMaster = new StudentLectureMaster();
  studentLectureMCQMasterList: StudentLectureMcqMaster []=[];
  studentLectureMCQMaster: StudentLectureMcqMaster = new StudentLectureMcqMaster();
  currentIndex: number = 0;

  allMCQ: number = 0;
  completedMCQ: number = 0;
  pendingMCQ: number = 0;
  completedPercent: number = 0;

  constructor(private router:Router,private mainService:MainserviceService,private authService:AuthService) { 

  }

  ngOnInit() {

    this.startExam();
  }

  startExam(){
    this.examfinish = false;
    this.studentLectureMaster = this.authService.getlectureMasterSession();
    this.getStudentLectureMasterById();
  }

  getStudentLectureMasterById(){

    let studentLectureMasterTemp = new StudentLectureMaster();
    studentLectureMasterTemp.studentLectureMasterId = this.studentLectureMaster.studentLectureMasterId;
    
      this.mainService.getStudentLectureMasterById(studentLectureMasterTemp).subscribe(data=>{

      this.studentLectureMaster = data;

      this.getStudentLectureMcqMasterListForAssessment();

    });

  }


  getStudentLectureMcqMasterListForAssessment(){

  let studentLectureMCQMasterTemp = new StudentLectureMcqMaster();

  let studentLectureMasterTemp = new StudentLectureMaster();
  studentLectureMasterTemp.studentLectureMasterId = this.studentLectureMaster.studentLectureMasterId;
  studentLectureMCQMasterTemp.studentLectureMasterTemp = studentLectureMasterTemp;

  
    this.mainService.getStudentLectureMcqMasterListForAssessment(studentLectureMCQMasterTemp).subscribe(data=>{

      this.studentLectureMCQMasterList = data;

      this.studentLectureMCQMasterList.forEach(studentLectureMCQMaster => {
        
        if(studentLectureMCQMaster.answerContentMaster != null) {


          studentLectureMCQMaster.mcqMaster.mcqOptionMasterList.forEach(mcqOptionMaster => {
            
            mcqOptionMaster.answerContentMasterId = studentLectureMCQMaster.answerContentMaster.answerContentMasterId;

            if(studentLectureMCQMaster.answerContentMaster.mcqOptionMasterId == mcqOptionMaster.mcqOptionMasterId) {
                mcqOptionMaster.selected = true;
            }

            if(mcqOptionMaster.isActualAnswer == true) {
                mcqOptionMaster.rightAnswer = true;
            }

            if(mcqOptionMaster.selected == true) {
                if (studentLectureMCQMaster.marks!! == 0) {
                    mcqOptionMaster.wrongAnswer = true;
                }
            }



          });

        // } else {
        //   studentLectureMCQMaster.
        }
  
      });

      if(this.studentLectureMCQMasterList.length > 0) {
        this.setMcqMasterByIndex(0);
      }


    });
  
  }

  setMcqMasterByIndex(index: number){
    this.currentIndex = index;
    this.setCurrentStudentLectureMCQMaster(this.currentIndex);
    
    if(this.currentIndex == 0) {
        this.showPreviousButton = false;
    } else {
      this.showPreviousButton = true;
    }

    if(this.currentIndex == this.allMCQ) {
      this.currentIndex--;
      this.setCurrentStudentLectureMCQMaster(this.currentIndex);
      this.endExam();

    } else {

        if((this.currentIndex+1) == this.allMCQ) {
            this.nextButtonText = "Submit";
            this.showNextButton = true;
            this.showCancelButton = false;

            if(this.studentLectureMCQMaster.answerContentMaster != null){
                this.showCancelButton = true;
                this.showNextButton = false;
            }

        } else {
            this.nextButtonText = "Next";
            this.showNextButton = true;
            this.showCancelButton = false;
        }

    }

  }

  endExam(){


    Swal.fire({
      customClass:{
        container:'logout-popup',
      },
      title: 'Are you sure you want to End Assessment?',
      
     
      
  showCancelButton: true,
  confirmButtonColor: '#faa41c',
  cancelButtonColor: '#fff',
  cancelButtonText:'Cancel',
  confirmButtonText: 'Yes'
      
  
    }).then((result) => {
      if (result.dismiss != null && result.dismiss != undefined) {
        Swal.close();
      }
      else {
        this.checkMCQ();
  
  }
    
    
    })


    
  }

  checkMCQ(){

    let studentLectureMasterTemp = new StudentLectureMaster();
    studentLectureMasterTemp.studentLectureMasterId = this.studentLectureMaster.studentLectureMasterId;
    studentLectureMasterTemp.studentLectureMcqMasterList = [];
    this.studentLectureMCQMasterList.forEach(studentLectureMCQMaster => {

      studentLectureMCQMaster.mcqMaster.mcqOptionMasterList.forEach(mcqOptionMaster => {

        if(mcqOptionMaster.selected == true) {
          studentLectureMCQMaster.selectedAnswerContentMaster = mcqOptionMaster;
        }

      });

      let mcqOptionMasterTemp = new MCQOptionMaster();
      mcqOptionMasterTemp.mcqOptionMasterId = studentLectureMCQMaster.selectedAnswerContentMaster.mcqOptionMasterId;


      let studentLectureMCQMasterTemp = new StudentLectureMcqMaster();
      studentLectureMCQMasterTemp.studentLectureMCQMasterId = studentLectureMCQMaster.studentLectureMCQMasterId;
      studentLectureMCQMasterTemp.selectedAnswerContentMaster = mcqOptionMasterTemp;

      studentLectureMasterTemp.studentLectureMcqMasterList.push(studentLectureMCQMasterTemp);

      
    });

      
    this.mainService.completeStudentLectureMaster(studentLectureMasterTemp).subscribe(data=>{

      this.studentLectureMaster = data;
      this.examfinish = true;
      this.showEndExamDialog = false;
      this.getStudentLectureMasterById();

    });

  }

  setCurrentStudentLectureMCQMaster(index: number){
    this.studentLectureMCQMaster = this.studentLectureMCQMasterList[index];
    this.setMCQMasterCounts(this.studentLectureMCQMasterList);
  }

  setMCQMasterCounts(studentLectureMCQMasterList: StudentLectureMcqMaster[]){

    this.allMCQ = 0;
    this.completedMCQ = 0;
    this.pendingMCQ = 0;
    this.completedPercent = 0;

    studentLectureMCQMasterList.forEach(studentLectureMCQMaster => {
      
      this.allMCQ += 1;

      if(studentLectureMCQMaster.isCompleted == true || studentLectureMCQMaster.answerContentMasterId != null) {
          this.completedMCQ += 1;
      }

    });

    this.pendingMCQ = this.allMCQ - this.completedMCQ;

    this.completedPercent = this.completedMCQ * 100 / this.allMCQ;
    
  }

  previousButton(){
    this.setMcqMasterByIndex(this.currentIndex - 1);
  }
  
  nextButton(){

    this.studentLectureMCQMaster.isCompleted = true

    let selectedMCQOptionMaster = new MCQOptionMaster()
    this.errorMessage = "";

    this.studentLectureMCQMaster.mcqMaster.mcqOptionMasterList.forEach(mcqOptionMaster => {
      
      if(mcqOptionMaster.selected == true) {
          selectedMCQOptionMaster = mcqOptionMaster;
      }

    });

    if(selectedMCQOptionMaster.mcqOptionMasterId == null) {
      this.errorMessage = "Please Select Any 1 Option";
      return;
    }

    this.setMcqMasterByIndex(this.currentIndex + 1);

  }


  backtoCourse(){
    this.router.navigateByUrl('/mycourse-details');
  }

  selectOption(mcqOptionMaster: MCQOptionMaster){

    this.studentLectureMCQMaster.mcqMaster.mcqOptionMasterList.forEach(mcqOptionMasterTemp => {

      mcqOptionMasterTemp.selected = false;

      if(mcqOptionMasterTemp.mcqOptionMasterId == mcqOptionMaster.mcqOptionMasterId) {
        mcqOptionMaster.selected = true;
      }

    });

  }

  // startExam(){

  //   this.examfinish=false;
  //   this.saveExamMasterAndGetExamMCQ("ALL");

  // }

  // downloadFile(fileUrl:string) {

  //   if(fileUrl === null){
  //       alert('No PDF to downlaod');
  //       return;
  //   }
  
  //   var fileUrlSplit = fileUrl.split("/");
  
  //   FileSaver.saveAs(fileUrl, fileUrlSplit[fileUrlSplit.length-1]);
  
  // }

}
